import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/wishlist/addEntry");

interface Props {
  id?: string;
  wishlistName?: string;
  productCode: string;
  quantity: number;
  priceReference?: string;
  optionalParts?: {
    productCode: string;
    quantity: number;
  }[];
}

export function sendData(data: Props) {
  const dataToSend = { ...data };
  if (data.id) {
    delete dataToSend.wishlistName;
  }

  return fetch(apiUrl, {
    body: JSON.stringify(dataToSend),
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((res) => {
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    return res;
  });
}
